import { Footer } from "../components/Footer"
import { PriorityMethods } from "../components/deposit/PriorityMethods"
import { TwoStepMethods } from "../components/deposit/TwoStepMethods"


export const DepositTwoStepPage = () => {
    return (
        <div className="container">
            <PriorityMethods />
            <TwoStepMethods />
            <Footer />
        </div>
    );
}